module.exports = __webpack_public_path__ + "static/media/mapping2.56cfc3c2.JPG";